
import {Component, Vue} from "vue-property-decorator";
import Template from "@/views/system-management/template/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import {constParser, timeParser} from "@/filters";
import InvoiceItem from "@/views/invoice/component/InvoiceItem.vue";
import InvoiceReconciliationDesc from "@/views/invoice/component/InvoiceReconciliationDesc.vue";
import UploadInvoice from "@/views/invoice/component/UploadInvoice.vue";
import ReconciliationInvoice from "@/views/invoice/component/ReconciliationInvoice.vue";
import BindTuiShuiInvoice from "@/views/invoice/component/BindTuiShuiInvoice.vue";
import BindNeiXiaoInvoice from "@/views/invoice/component/BindNeiXiaoInvoice.vue";
import {
  downloadInvoice,
  invoiceCodeOpts,
  page,
  remove,
  updateCertificationDate,
  updateRemark
} from "@/api/invoice/index.ts";
import {INVOICE_AL_STATUS, INVOICE_RE_STATUS, INVOICE_TYPE} from "@/constant";
import {getUserByRole} from "@/api/users";
import _ from "lodash";
import {exportJson2Excel} from "@/utils/excel";
import {formatJson} from "@/utils";
import {deepClone} from "@/utils/deepClone";
import BindReceiptDesc from "@/views/invoice/component/BindReceiptDesc.vue";
import {findSuppliersByKeyword, getAbbreviation} from "@/api/supplier";
import {updateInvoiceSupplier} from "@/api/invoice";

@Component({
  name: "invoice",
  methods: {
    INVOICE_RE_STATUS() {
      return INVOICE_RE_STATUS
    }, constParser, timeParser
  },
  components: {
    BindReceiptDesc,
    BindNeiXiaoInvoice,
    BindTuiShuiInvoice,
    ReconciliationInvoice,
    UploadInvoice,
    InvoiceReconciliationDesc,
    InvoiceItem,
    Pagination,
    Template
  },
})
export default class Invoice extends Vue {

  public searchForm = [
    {
      label: "报关合同号",
      prop: "bookingOrderCode",
      key: "bookingOrderCode",
      type: "select",
      value: "",
      options: [],
      clearable: true,
      remote_method: _.throttle(this.getBookingOrderCode, 1000),
      remote: true,
      resetKey: {label: "name", value: "value"},
    },
    {
      label: "开票资料号",
      prop: "factoryInvoiceCode",
      key: "factoryInvoiceCode",
      type: "select",
      value: "",
      options: [],
      clearable: true,
      remote_method: _.throttle(this.getFactoryInvoiceCode, 1000),
      remote: true,
      resetKey: {label: "name", value: "value"},
    },
    {
      label: "采购员",
      prop: "purchaser",
      key: "purchaser",
      type: "select",
      value: "",
      options: [],
      clearable: true,
      resetKey: {label: "abbreviation", value: "id"},
    },
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      type: "select",
      clearable: true,
      value: "",
      options: [],
      remote_method: _.throttle(this.getSupplierList, 1000),
      remote: true,
      resetKey: {label: "name", value: "value"},
    },
    {
      label: "发票号码",
      prop: "code",
      key: "code",
      type: "input",
      value: "",
      options: [],
      clearable: true,
      resetKey: {label: "name", value: "value"},
    },
    {
      label: "发票类型",
      prop: "type",
      key: "type",
      type: "select",
      options: INVOICE_TYPE,
      value: "",
      clearable: true,
      resetKey: {label: "name", value: "value"},
    },
    {
      label: "分配状态",
      prop: "allocateStatus",
      key: "allocateStatus",
      type: "select",
      options: INVOICE_AL_STATUS,
      value: "NONE",
      clearable: true,
      resetKey: {label: "name", value: "value"},
    },
    {
      label: "核销状态",
      prop: "reconciliationStatus",
      key: "reconciliationStatus",
      type: "select",
      clearable: true,
      options: INVOICE_RE_STATUS,
      value: "",
      resetKey: {label: "name", value: "value"},
    },
    {
      label: "应付会计",
      prop: "accountant",
      key: "accountant",
      type: "select",
      clearable: true,
      value: "",
      options: [],
      resetKey: {label: "name", value: "value"},
    },
    {
      label: "采购订单号码",
      prop: "purchaseOrderCode",
      key: "purchaseOrderCode",
      type: "select",
      clearable: true,
      value: "",
      options: [],
      remote_method: _.throttle(this.getPurchaseOrderCode, 1000),
      remote: true,
      resetKey: {label: "name", value: "value"},
    },
    {
      label: "装箱单号",
      prop: "hqPackingListCode",
      key: "hqPackingListCode",
      type: "select",
      clearable: true,
      value: "",
      options: [],
      remote_method: _.throttle(this.getPackingListCode, 1000),
      remote: true,
      resetKey: {label: "name", value: "value"},
    },

  ]

  public getUserList() {
    getUserByRole('采购员')
        .then((data) => {
          this.searchForm[2].options = data;
        })
    getUserByRole('应付会计')
        .then((data) => {
          this.searchForm[8].options = data;
        })
  }

  public getBookingOrderCode(name: "") {
    invoiceCodeOpts({type: "BOOKING_ORDER", code: name})
        .then(({data}) => {
              const res = (data as any).list.map(i => {
                return {name: i, value: i}
              })
              this.searchForm[0].options = res;
            }
        )
  }

  public getFactoryInvoiceCode(name: "") {
    invoiceCodeOpts({type: "FACTORY_INVOICE", code: name})
        .then(({data}) => {
              const res = (data as any).list.map(i => {
                return {name: i, value: i}
              })
              this.searchForm[1].options = res;
            }
        )
  }

  public getSupplierList(name:"") {
    getAbbreviation({abbreviation: name})
        .then((data) => {
          const res = (data as any).map(i => {
            return {name: i.abbreviation, value: i.id}
          })
          this.searchForm[3].options = res;
        })
  }
  public getPurchaseOrderCode(name: "") {
    invoiceCodeOpts({type: "PURCHASE_ORDER", code: name})
        .then(({data}) => {
              const res = (data as any).list.map(i => {
                return {name: i, value: i}
              })
              this.searchForm[9].options = res;
            }
        )
  }

  public getPackingListCode(name: "") {
    invoiceCodeOpts({type: "HQ_PACKING_LIST", code: name})
        .then((res) => {
              const data = (res.data as any);
              this.searchForm[10].options = data.list.map(i => {
                return {name: i, value: i}
              })
            }
        )
  }

  private queryForm = {bookingOrderCode: null};

  public querySearch(data) {
    this.table.pageNumber = 1;
    this.queryForm = data && data !== "reset" ? data : {};
    this.getList();
  }

  public handleUpload(clickUploadExcFile:boolean) {
    (this.$refs['uploadInvoiceRef'] as UploadInvoice)
        .openDialog(clickUploadExcFile)
  }

  public selectInvoice = []

  public handleBatchDownload() {
    this.selectInvoice.forEach(i => {
      this.handleDownload({row: i})
    })
  }

  public handlePageDownload() {
    let list: any[];
    if (this.selectInvoice.length !== 0) {
      list = deepClone(this.selectInvoice);
    } else {
      list = deepClone(this.table.list);
    }
    const headers = this.tableCol.filter(v => v.label != '操作').map((v) => v.label);
    const fieldNames = this.tableCol.filter(v => v.label != '操作').map((v) => v.key);
    exportJson2Excel(
        headers,
        formatJson(fieldNames, list), `发票管理-${new Date()}`
    );
  }

  public handleSelectionChange(val) {
    this.selectInvoice = val;
  }

  public handleReceipt({row}) {
    if (row.type == "TUI_SHUI") {
      (this.$refs['bindTuiShuiInvoiceRef'] as BindTuiShuiInvoice)
          .openDialog(row, {title: "绑定退税发票"})
    } else {
      (this.$refs['bindNeiXiaoInvoiceRef'] as BindNeiXiaoInvoice)
          .openDialog(row, {title: "绑定内销发票"})
    }
  }

  public handleDownload({row}) {
    downloadInvoice({id: row.id})
        .then(() => {
          this.$notify({
            title: "提示",
            message: "下载成功！",
            type: "success",
            duration: 2000,
          });
        })
  }

  public handleReconciliation({row}) {
    (this.$refs['reconciliationInvoiceRef'] as ReconciliationInvoice)
        .openDialog(row, {title: "付款单核销"})
  }

  public handleDelete({row}) {
    remove(row.id).then(() => {
      this.$notify({
        title: "提示",
        message: "删除成功！",
        type: "success",
        duration: 2000,
      });
      this.getList()
    })
  }

  public async handleRemark(row) {
    await updateRemark({id: row.id, remark: row.remark});
    this.$notify({
      title: "提示",
      message: "修改备注成功！",
      type: "success",
      duration: 2000,
    });
    this.getList()
  }

  public handleBindDesc({row}) {
    (this.$refs['bindReceiptDescRef'] as BindReceiptDesc).openDialog(row)
  }

  public handleProjectName(row, prop) {
    (this.$refs['invoiceItemRef'] as InvoiceItem).openDialog(row)
  }

  public handleStatus(row, prop) {
    (this.$refs['invoiceReconciliationDescRef'] as InvoiceReconciliationDesc).openDialog(row)
  }

  public async handleCertificationDate(row) {
    await updateCertificationDate({id: row.id, certificationDate: row.newCertificationDate});
    row.certificationDate = row.newCertificationDate;
    row.isCertificationDate = false;
    this.$notify({
      title: "提示",
      message: "修改认证时间成功！",
      type: "success",
      duration: 2000,
    });
    // todo 目前原因是在这里，暂时注释处理
   // await this.getList();
  }

  public handleOpenCertificationDate(row, refName) {
    row.isCertificationDate = true;
    (this.$refs[refName] as any).$refs.popper.hidden = true
  }

  private loading = true;
//发票号码	增值税发票号码	销售方名称	项目名称	发票金额	税额	数量	开票单位	采购员	应付会计	付款核销	发票类型	剩余未分配	关联单据	开票资料号码	采购订单号码	认证时间	操作	备注（文本）
  private tableCol = [
    {
      label: "开票日期",
      prop: "invoiceDate",
      key: "invoiceDate",
      width: 120,
      fixed: true
    },
    {
      label: "发票号码",
      prop: "code",
      key: "code",
      width: 120,
      fixed: true,
      type:"sn-popver",
      show: true,
      disabled: false,
      icon: require("@/assets/images/ic_jr.png"),
      icon_key: "company",
      icon_value: "JR",
      content: "嘉锐",
    },
    {
      label: "增值税发票号码",
      prop: "taxInvoiceCode",
      key: "taxInvoiceCode",
      width: 120,
      fixed: true
    },
    {
      label: "销售方名称",
      prop: "factoryName",
      key: "factoryName",
      type: "custom",
      slot: "fn",
      width: 120,
      fixed: true,
      icon: require("@/assets/images/ic_origin_supplier.png"),
      icon_key: "modifiedSupplier",
      icon_value: true,
      content: "originalSupplier",
    },
    {
      label: "项目名称",
      prop: "projectName",
      key: "projectName",
      type: "custom",
      slot: "pn",
    },
    {
      label: "数量",
      prop: "num",
      key: "num",
    },
    {
      label: "开票单位",
      prop: "units",
      key: "units",
    },
    {
      label: "发票金额",
      prop: "amount",
      key: "amount",
    },
    {
      label: "采购员",
      prop: "purchaser",
      key: "purchaser",
    },
    {
      label: "应付会计",
      prop: "accountant",
      key: "accountant",
    },
    {
      label: "付款核销",
      prop: "reconciliationStatus",
      key: "reconciliationStatus",
      type: "custom",
      slot: "status",
    },
    {
      label: "发票类型",
      prop: "type",
      key: "type",
      render: (prop, row) => {
        return constParser(row.type, INVOICE_TYPE);
      }
    },
    {
      label: "剩余未分配",
      prop: "unAllocateAmount",
      key: "unAllocateAmount",
    },
    {
      label: "关联单据",
      prop: "relationOrderCodes",
      key: "relationOrderCodes",
    },
    {
      label: "开票资料号码",
      prop: "factoryInvoiceCodes",
      key: "factoryInvoiceCodes",
    },
    {
      label: "采购订单号码",
      prop: "purchaseOrderCodes",
      key: "purchaseOrderCodes",
    },
    {
      label: "认证时间",
      prop: "certificationDate",
      key: "certificationDate",
      type: "custom",
      slot: "cd",
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "绑定单据",
          code: "",
          click: "handleReceipt",
          show: (row) => {
            if (row.type == 'SHOU_GONG') {
              return false;
            }
            // 未核销
            return row.reconciliationStatus != 'COMPLETED';
          }
        },
        {
          name: "绑定明细",
          code: "",
          click: "handleBindDesc",
          show: (row) => {
            if (row.type == 'SHOU_GONG') {
              return false;
            }
            return row.reconciliationStatus == 'COMPLETED';
          }
        },
        {
          name: "下载",
          code: "",
          click: "handleDownload",
        },
        {
          name: "付款核销",
          code: "",
          click: "handleReconciliation",
          key: "reconciliationStatus",
          value: "[PENDING, PART]",
          show: (row) => {
            return row.unAllocateAmount == 0;
          }
        },
        {
          name: "付款核销",
          code: "",
          click: "handleReconciliation",
          key: "reconciliationStatus",
          value: "COMPLETED",
          color: "color-red",
          show: (row) => {
            return row.unAllocateAmount == 0;
          }
        },
        {
          name: "指定工厂",
          type: "popoverRemoteSelect",
          prop:"",
          remote_method: this.querySpecifySupplier,
          show: (row) => {
            return row.modifiedSupplier !== true;
          },
          options: [],
          resetKey: {label: "abbr", value: "name"},
        },
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
          show: (row) => {
            return row.reconciliationStatus != 'COMPLETED';
          }
        },
      ],
      width: 250,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      length: 255,
    },
  ]
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };

  public getList() {
    this.loading = true;
    page(this.queryForm, {pageNumber: this.table.pageNumber, pageSize: this.table.pageSize})
        .then((res) => {
              const data = (res as any).data;
              this.table.total = Number(data.total);
              this.table.list = data.list.map(i=>{
                i.relationOrderCodes = this.filterRelateReceipt(i)
                i.factoryInvoiceCodes = this.filterReceipt('FACTORY_INVOICE', i)
                i.purchaseOrderCodes = this.filterReceipt('PURCHASE_ORDER', i)
                return i
              });
            }
        )
        .finally(() => this.loading = false)
  }

  created() {
    const query = this.$route.query;
    if (query?.bookingOrderCode) {
      this.searchForm[0].options = [{name: query.bookingOrderCode, value: query.bookingOrderCode}]
      this.searchForm[0].value = query.bookingOrderCode as string;
      this.queryForm.bookingOrderCode = query.bookingOrderCode as string;
    }
    this.getList()
    this.getUserList()
  }

  private filterReceipt(type, row) {
    return row.relationCodes?.filter(i => i.type == type).map(i => i.code).join(',');
  }

  private filterRelateReceipt(row) {
    if (row.type == 'NEI_XIAO') {
      return row.relationCodes?.filter(i => i.type == 'DELIVERY_LIST' || i.type == 'FACTORY_LOADING_PLAN').map(i => i.code).join(',');
    } else {
      return row.relationCodes?.filter(i => i.type == 'BOOKING_ORDER').map(i => i.code).join(',');
    }
  }

  private handleReconciliationColor(row) {
    if (row.reconciliationStatus !== 'COMPLETED') {
      return "main-color";
    }else {
      return "color-red";
    }
  }

  private async querySpecifySupplier(name) {
    if (name != '') {
      let data: any = await findSuppliersByKeyword(name);
      this.tableCol[17].options[5].options = [...data];
    }
  }

  private async handleSelectChange({val,row,column}) {
    await updateInvoiceSupplier(row.row.id, val).then(() => {
      this.$notify({
        title: '提示',
        message: '更新完毕'
      });
      this.tableCol[17].options[5].prop = "";
      this.getList();
    }).catch(() => {
      this.$notify({
        title: '提示',
        message: '更新失败'
      });
    });
  }

}
